module.exports = __webpack_public_path__ + "6d5e639f2db8922e9f886c6eb6030cdb.svg";